var Vue = require('vue').default
var httpr = require('../../../vcomps/httpr')

var time = {}

// 防止过快点击
function clear(url) {
    clearTimeout(time[url])
    time[url] = null
}

function post(url, data, callback) {
    if (time[url]) {
        return
    }
    time[url] = setTimeout(function () {
        clear(url)
    }, 2000)
    httpr.post(url, Object.assign(data, {account: Vue.prototype.user_data.account}), (err, result) => {
        clear(url)
        callback(err ? '网络异常' : err, result)
    })
}

// 防止过快点击

var api = {
    get_captcha        : (tel, callback) => post("/appointments/get_captcha", {tel}, callback),
    login              : (tel, captcha, shave_tel, callback) => post("/pre_draw_202407/login", {
        tel,
        captcha,
        shave_tel
    }, callback),
    lottery            : (number, callback) => post("/pre_draw_202407/lottery", {number}, callback),
    update_config      : (item_ids, callback) => post("/pre_draw_202407/update_config", {item_ids}, callback),
    determine_config   : (callback) => post("/pre_draw_202407/determine_config", {}, callback),
    select_lottery_list: (callback) => post("/pre_draw_202407/select_lottery_list", {}, callback),
    select_config      : (callback) => post("/pre_draw_202407/select_config", {}, callback),
    get_data           : (callback) => post("/pre_draw_202407/get_data", {}, callback),
    ok_task            : (task_id, callback) => post("/pre_draw_202407/ok_task", {task_id}, callback),
}
Vue.prototype.$httpr = api

module.exports = api